import React, { ComponentType } from 'react';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { Container } from '@uds/grid';

import Ribbon from '../Ribbon';
import DomainSearchSuggestions, {
  DomainSearchSuggestionsDesignProps,
  DomainSearchSuggestionsTextProps,
  DomainSearchSuggestionsAnalyticsProps,
} from './components/DomainSearchSuggestions';

interface OuterProps extends RibbonProps {
  design: DomainSearchSuggestionsDesignProps;
  text: DomainSearchSuggestionsTextProps;
  visibilitySet: boolean;
  experiences: unknown;
  analytics: DomainSearchSuggestionsAnalyticsProps;
}

const ConnectedDomainSearchSuggestions = (props: OuterProps) => {
  return (
    <Ribbon
      id={props.id}
      name={props.name}
      type={Type.DOMAIN_SEARCH_RESULTS}
      colorway={props.colorway}
      layout={props.layout}
      loading={props.loading}
      flush={true}
    >
      <Container>
        <DomainSearchSuggestions {...props} />
      </Container>
    </Ribbon>
  );
};

ConnectedDomainSearchSuggestions.displayName = 'DomainSearchSuggestions';

export default errorBoundary(visibilitySet(ConnectedDomainSearchSuggestions)) as ComponentType<OuterProps>;
